import {t} from 'i18next';
import React from 'react';
import ContextMenu from '../../../incase-domain/components/contextMenu/ContextMenu';
import {IElement} from '../../../incase-domain/elements';

interface ImageGalleryItemContextMenuProps {
    menuId: string;
    element: IElement;
    onMoveUp: (imageId: string) => void;
    onMoveDown: (imageId: string) => void;
    onDelete: (imageId: string) => void;
}

function ImageGalleryItemContextMenu(props: React.PropsWithChildren<ImageGalleryItemContextMenuProps>): JSX.Element | null {
    const {menuId, element, onMoveUp, onMoveDown, onDelete, children} = props;

    const contextMenuItems = [
        [
            {
                label: t('contextMenuElement.moveUp'),
                icon: 'solar:arrow-up-linear',
                onClick: () => onMoveUp(element.id),
                disabled: false,
            },
            {
                label: t('contextMenuElement.moveDown'),
                icon: 'solar:arrow-down-linear',
                onClick: () => onMoveDown(element.id),
                disabled: false,
            },
        ],
        [
            {
                label: t('contextMenuElement.delete'),
                icon: 'solar:trash-bin-minimalistic-linear',
                onClick: () => onDelete(element.id),
                disabled: false,
            },
        ],
    ];

    return (
        <>
            <ContextMenu menuId={menuId} items={contextMenuItems}>
                {children}
            </ContextMenu>
        </>
    );
}

export default ImageGalleryItemContextMenu;
